import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { SupplierStatusEnum } from '../enums/supplier-status.enum';
import { SupplierTypeEnum } from '../enums/supplier-type.enum';

/**
 * Suppliers filters
 */
export class SuppliersFilters extends ApiRequestFilters {
	/**
	 * Countries id values
	 */
	countries?: number[];

	/**
	 * Status values
	 */
	statuses?: SupplierStatusEnum[];

	/**
	 * Type values
	 */
	types?: SupplierTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
